export default __webpack_public_path__ + "static/media/15-unpacking.f7972353.svg";